var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBoxOpen = function SvgBoxOpen(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 182,
    viewBox: "0 0 227 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.9443 53.2928C77.7983 52.9154 77.4354 52.6666 77.0307 52.6666L35.4292 52.6666C34.7409 52.6666 34.2673 53.3577 34.5156 53.9996L42.9645 75.84L86.6666 75.84L77.9443 53.2928Z",
    fill: "url(#paint0_linear_264_38892)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_264_38892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.0502 76.0151L184.164 76.0151L184.164 142.623C184.164 148.033 179.779 152.419 174.369 152.419L55.8455 152.419C50.4357 152.419 46.0502 148.033 46.0502 142.623L46.0502 76.0151Z",
    fill: "url(#paint1_linear_264_38892)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.453 76.0151L184.165 76.0151L184.165 142.623C184.165 148.033 179.779 152.419 174.369 152.419L146.453 152.419L146.453 76.0151Z",
    fill: "url(#paint2_linear_264_38892)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.563 55.1103C153.704 54.7232 154.072 54.4655 154.484 54.4655L190.601 54.4655C191.281 54.4655 191.754 55.141 191.522 55.7798L184.163 76.0153L145.961 76.0153L153.563 55.1103Z",
    fill: "url(#paint3_linear_264_38892)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0507 76.0151L145.963 76.0151L140.828 96.556C140.392 98.3002 138.825 99.5239 137.027 99.5239L45.1917 99.5239C42.6427 99.5239 40.7723 97.1284 41.3906 94.6554L46.0507 76.0151Z",
    fill: "#E3F2FD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.84,
    y: 83.8515,
    width: 27.4269,
    height: 7.83626,
    rx: 1.95907,
    fill: "#8BCAFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_264_38892",
    x1: 59.9913,
    y1: 52.6666,
    x2: 51.7116,
    y2: 117.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79C2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_264_38892",
    x1: 114.617,
    y1: 86.3002,
    x2: 115.825,
    y2: 152.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3F2FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_264_38892",
    x1: 165.554,
    y1: 76.0151,
    x2: 149.881,
    y2: 154.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79C2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_264_38892",
    x1: 169.279,
    y1: 54.4655,
    x2: 177.453,
    y2: 114.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBDEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79C2FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_264_38892"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 153.787,
    height: 153.787,
    fill: "white",
    transform: "translate(38.2134 -3.05176e-05)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBoxOpen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "box-open.d40e87e7fd02d0b9baedbca7b59ac2b6.svg";